export default __webpack_public_path__ + "static/media/ModernHome.9d73ece7.jpg";